// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Dev Firebase configuration, not required for sandbox/production, as they have Mobile Apps
const devFirebaseConfig = {
  apiKey: "AIzaSyCIhVkfOGHOH0vCyNOO7Xo-0M4_XGVAVOg",
  authDomain: "onthemonee-dev.firebaseapp.com",
  projectId: "onthemonee-dev",
  storageBucket: "onthemonee-dev.appspot.com",
  messagingSenderId: "354309145383",
  appId: "1:354309145383:web:2dd3c3c3722775b6eb9f02",
};

const devVapidKey = "BHIUhc31JjJQY9snIv3ofxk8ICJUIcCBrrwQZV2Vz6SY0ykqT07Le3QD1UPag0_m50Bk7pHhiTYbF0Y1yslqStw";

// Initialize Firebase
const app = initializeApp(devFirebaseConfig);

const messaging = getMessaging(app);

export const getMessagingToken = (setTokenFound, storeToken) => {
  return getToken(messaging, {
    vapidKey: devVapidKey,
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        setTokenFound(true);
        storeToken(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log("No registration token available. Request permission to generate one.");
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
